var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 960",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 960) scale(1 -1)",
    d: "M243 73Q205 73 178.5 99.5Q152 126 152 164L152 558Q152 595 178.5 622Q205 649 243 649L276 649L276 722Q276 807 335.5 866.5Q395 926 480 926Q565 926 624.5 866.5Q684 807 684 722L684 649L717 649Q755 649 781.5 622Q808 595 808 558L808 164Q808 126 781.5 99.5Q755 73 717 73ZM480 281Q480 281 496.5 281Q513 281 536.5 304.5Q560 328 560 361Q560 394 536.5 417.5Q513 441 480 441Q447 441 423.5 417.5Q400 394 400 361Q400 328 423.5 304.5Q447 281 480 281ZM367 649L593 649L593 722Q593 769 560 802Q527 835 480 835Q433 835 400 802Q367 769 367 722Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bf0bca20ddda18233446524506df3935.svg";
export { ForwardRef as ReactComponent };